import {CommonModule} from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ModalConfig, ModalLandPlatformService} from '@sp401/modal-engine';
import {ToastObject} from 'src/app/interfaces/toast-object';
import {UserMessageModalComponent} from 'src/app/modal/user-message-modal/user-message-modal.component';
import {TranslationService} from 'src/app/services/translation.service';
import {UtilService} from 'src/app/services/util.service';
import {AssetPipe} from "../../pipes/asset.pipe";

@Component({
  selector: 'notification-toast',
  standalone: true,
  imports: [CommonModule, FormsModule, AssetPipe],
  templateUrl: './notification-toast.component.html',
  styleUrl: './notification-toast.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NotificationToastComponent implements OnInit, OnDestroy {

  toastType: any;
  desciption: any;
  errorCode: any;
  showToast: boolean = false;
  toastMessageSubscribe: any;
  translationToastMessage: any;
  toastIcon: any = {
    Success: 'successIcon',
    Error: 'errorIcon',
    Alert: 'alertIcon'
  }

  toastIconCss: any = {
    Success: 'toast-icon success',
    Error: 'toast-icon error',
    Alert: 'toast-icon alert'
  }

  private messageModalConfig: ModalConfig = {
    modalId: 'user_message_modal',
    type: "simple",
    dismissible: true,
    title: '',
    level: "INFO",
    contentConfig: {
      componentRender: UserMessageModalComponent
    }
  }

  constructor(private utilService: UtilService,
              private translationService: TranslationService,
              private _modal: ModalLandPlatformService
  ) {

  }

  ngOnInit() {
    this.translationToastMessage = this.translationService.getTranslationForPage('toastMessage');
    this.toastMessageSubscribe = this.utilService.toastMessage$.subscribe((toastObject: ToastObject) => {
      if (toastObject) {
        this.utilService.showPopUpMessage(toastObject);
        this._modal.triggerAddModal(this.messageModalConfig)
      }
    });
  }

  closeToast() {
    this.showToast = false;
  }

  ngOnDestroy(): void {
    this.toastMessageSubscribe?.unsubscribe();
  }

}
